export const practicalAiApplication = {
  '@context': 'https://schema.org',
  '@type': 'Event',
  name: 'Practical Application of AI in Materials Trading Industry Webinar',
  startDate: '2023-10-25',
  description:
    'A webinar organized by Boldare to share practical insights on how Artificial Intelligence can enhance efficiency in the materials trading industry. Romuald Członkowski, Head of AI Solutions, presented AI trends, shared experience in building AI solutions, and provided specific tips for bulk materials trading and cargo management.',
  organizer: {
    '@type': 'Organization',
    name: 'Boldare',
    url: 'https://www.boldare.com',
  },
  performer: {
    '@type': 'Person',
    name: 'Romuald Członkowski',
    jobTitle: 'Head of AI Solutions',
  },
  url: 'https://www.boldare.com/practical-ai-application/',
};
